<template>
  <div
    class="collection-product-card"
    :class="{
      'catalog-block-left': isLeftDirection,
      'catalog-block-right': !isLeftDirection,
    }"

    :data-product-id="product?.id"
    :data-product-slug="product?.slug"
    :data-product-page="currentPage"

    @click="addEcommerce('click', product as IProduct)"
  >
    <div
      title="Добавить в избранное"
      class="wish"
    >
      <WishBtn :product-id="Number(product?.id)" />
    </div>

    <div class="catalog-block__information">
      <div class="catalog-block__type">Коллекция</div>
      <div
        v-html="product?.name"
        class="catalog-block__name"
      />
      <div v-if="specifications.length" class="catalog-block__specifications">
        <span
          v-for="(_text, index) in specifications"
          :key="`specifications-${ index }`"
          v-html="_text"
        />
      </div>
      <div class="catalog-block__prices">
        <div class="catalog-block__current-price">
<!--          {{ product?.price }} ₽-->
          {{ $priceFormat({amount: product?.price, decimalCount: 0 }) }} ₽
        </div>

        <div
          v-if="product?.oldPrice"
          class="catalog-block__old-price"
        >
          {{ $priceFormat({ amount:product?.oldPrice, decimalCount: 0 }) }} ₽
        </div>
      </div>
      <div class="catalog-block__bottom">
        <nuxt-link
          :to="product?.url"
          class="catalog-block__button button button-primary"
        >
          Открыть коллекцию
        </nuxt-link>
      </div>
    </div>

    <div class="catalog-sale-block">
      <div
        v-if="promotionLabel"
        v-html="promotionLabel"
        class="catalog-block__stock"
      />
    </div>

    <nuxt-img
      class="catalog-block__image"
      :src="String(imageId)"
    />
    <nuxt-link
      :to="product?.url"
      class="collection-product-card__link"
    />
  </div>
</template>

<script setup lang="ts">
import type { IProduct } from '#sitis/internal/controllers/products/models/Product';
import WishBtn from '~/components/UI/WishBtn.vue';
import type { IWishlistItem } from '#sitis/internal/controllers/wish/models/WishlistItem';
import useEcommerce from '~/composables/useEcommerceYandex';
import type {ComputedRef} from "vue";
import {getCharacteristicFromFull} from "~/utils/getCharacteristic";
import caseWords from "~/utils/caseWords";
import getDiscountLabel from "~/utils/getDiscountLabel";

const { $priceFormat } = useNuxtApp();

const { addEcommerce } = useEcommerce();
const { page, product } =
  defineProps <{
  product:IProduct | IWishlistItem,
  page?:number|undefined|string,
  }>();

const currentPage = ref<number|undefined|string>('');
currentPage.value = page;

const isLeftDirection: ComputedRef<boolean> = computed(() => {
  const _value: string = (product.shortCharacteristics || []).find((t) => Boolean(t.slug === 'tip-bannera'))?.values?.[0]?.slug || '';
  return Boolean(_value === 'tekst-s-levoj-storony');
});
const imageId: ComputedRef<number> = computed(() => {
  const _product: any = product;
  return _product?.dynamicFields?.banners_ids?.[0] || product?.imageId
});

const specifications: ComputedRef<string[]> = computed(() => {
  let _list: string[] = [];

  const _colors = ((product?.shortCharacteristics || []).find((t: any) => Boolean(t?.slug === 'collection_color'))?.values || []).length;
  if (_colors > 0) {
    _list.push(`${ _colors } ${ caseWords(_colors, ['цвет', 'цвета', 'цветов']) }`)
  }

  const _countProducts = product.productSetChildrenCount || 0;
  if (_countProducts > 0) {
    _list.push(`${ _countProducts } ${ caseWords(_countProducts, [
      'предмет мебели',
      'предмета мебели',
      'предметов мебели'
    ])}`)
  }

  return _list
});
const promotionLabel: ComputedRef<string> = computed(() => {
  const _item = getDiscountLabel(product);
  return _item?.label || ""
})
</script>

<style scoped lang="scss">
.collection-product-card {
  padding: 60px;
  width: 100%;
  display: -webkit-box;
  display: flex;
  margin-bottom: 18px;
  position: relative;

  & .wish {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 15;
    display: block;
  }

  &:hover {
    box-shadow: 0 0 10px 1px #000000a1;
    border-radius: 5px;
    overflow: hidden;
  }
}

.catalog-block__information {
  flex: auto;
  max-width: 37%;
}

.catalog-block__image {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  object-fit: cover;
  object-position: center;
}

.catalog-block__type {
  font-size: 24px;
  line-height: 17px;
  color: rgb(255 255 255 / 80%);
}

.catalog-block__name {
  font-weight: 700;
  font-size: 75px;
  line-height: 97px;
  color: #fff;
}

.catalog-block__specifications {
  font-size: 18px;
  line-height: 23px;
  color: #fff;
  margin-right: -29px;
  margin-bottom: 35px;

  & > * {
    margin-right: 29px
  }
}

.catalog-block__prices {
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-bottom: 131px;
}

.catalog-block__current-price {
  font-weight: 700;
  font-size: 48px;
  line-height: 62px;
  text-align: right;
  color: #fff;
}

.catalog-block__old-price {
  font-size: 32px;
  line-height: 41px;
  text-align: right;
  text-decoration-line: line-through;
  color: rgb(255 255 255 / 80%);
}

.catalog-block__button {
  text-decoration: none;
  position: relative;
  z-index: 2;
}

.catalog-sale-block {
  padding-left: 53px;
  padding-top: 46px;
}

.catalog-block__stock {
  background: red;
  padding: 5px;
  font-size: 24px;
  line-height: 31px;
  color: #fff;
  min-width: 152px;
}

.catalog-block-right {
  justify-content: flex-end;

  & .catalog-block__information {
    order: 2;
  }

  & .catalog-block__bottom {
    display: flex;
    justify-content: flex-end;
  }
}

.collection-product-card__link {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  z-index: 1;
}

@media screen and (max-width: 1199px) {
  .catalog-block__information {
    flex: auto;
    max-width: initial;
  }
}

@media screen and (max-width: 1023px) {
  .collection-product-card{
    flex-direction: column;
    padding: 10px 20px;
  }

  .product-card {
    flex-direction: column-reverse;
    padding: 10px 20px;
    margin-bottom: 3px;
  }

  .catalog-block__information {
    max-width: 100%;
  }

  .catalog-block__type {
    font-size: 16px;
    line-height: 21px;
  }

  .catalog-block__name {
    font-size: 32px;
    line-height: 41px;
  }

  .catalog-block__specifications {
    font-size: 14px;
    line-height: 18px;
    display: flex;
    flex-direction: column;
    margin-right: 0;
    margin-bottom: -40px;

    & > * {
      margin-right: 29px;
      margin-bottom: 7px;
    }
  }

  .catalog-block__prices {
    margin-bottom: 18px;
  }

  .catalog-block__current-price {
    font-size: 24px;
    line-height: 31px;
  }

  .catalog-block__old-price {
    font-size: 14px;
    line-height: 18px;
  }

  .catalog-block__bottom {
    display: flex;
  }

  .catalog-block__bottom .button-primary {
    color: rgb(255 0 0);
    background: rgb(255 255 255 / 60%);
  }

  .catalog-block__button {
    margin-left: auto;
  }

  .catalog-block__stock {
    font-size: 18px;
    line-height: 23px;
    min-width: auto;
  }

  .catalog-sale-block {
    padding-top: 0;
    padding-left: 0;
    margin-bottom: 21px;
    display: flex;
  }

  .catalog-block__right {
    padding-top: 0;
    padding-left: 0;
    margin-bottom: 21px;
    display: flex;

    & .catalog-sale-block {
      padding-right: 53px
    }

    & .catalog-block__information {
      -webkit-box-ordinal-group: 3;
      order: 2;
    }
  }
}

</style>
<style lang="scss">
.catalog-block__name {
  b, strong {
    font-weight: 600;
  }
}
</style>
